import { render, staticRenderFns } from "./MessageBase.vue?vue&type=template&id=f61a0d48&"
import script from "./MessageBase.vue?vue&type=script&lang=js&"
export * from "./MessageBase.vue?vue&type=script&lang=js&"
import style0 from "./MessageBase.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports